import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getModel } from './selectors';
import * as sensorActions from '../sensorActions';
import { isSmSeAsset } from '../helpers';
import OperationalParametersComponent from './OperationalParametersComponent';
import { withErrorBoundaryTrigger } from 'sharedComponents/ErrorBoundary';
import { clearDownloadMeasurementStore, clearOperationalParametersApiErrors } from '../actions';

const OperationalParametersContainer = (props) => {
    const { model, actions } = props;

    useEffect(() => {
        return () => {
            // Clear store on unmount so APIs re-trigger when user returns to this tab or retries
            actions.clearDownloadMeasurementStore();
            actions.clearOperationalParametersApiErrors();
        };
    }, []);

    useEffect(() => {
        if (isSmSeAsset(props.asset) &&
            model.assetDetails?.details &&
            model.assetDetails?.details?.sensorIdentifier !== model.sensorProperties?.data?.sensorIdentifier &&
            props.asset?.isMonitored &&
            model.assetDetails?.details?.sensorId) {
            actions.getSensorProperties(model.assetDetails?.details?.sensorId);
            actions.getSensorGatewayInfo(model?.assetDetails?.details?.sensorId);
        }
    }, [model.assetDetails?.details]);

    return <OperationalParametersComponent {...props} />;
};
OperationalParametersContainer.propTypes = {
    model: PropTypes.shape({
        assetDetails: PropTypes.shape({
            details: PropTypes.object,
        }),
        sensorProperties: PropTypes.shape({
            data: PropTypes.object,
        }),
    }),
    actions: PropTypes.shape({
        getSensorProperties: PropTypes.func,
        getSensorGatewayInfo: PropTypes.func,
        clearDownloadMeasurementStore: PropTypes.func,
        clearOperationalParametersApiErrors: PropTypes.func,
    }),
    asset: PropTypes.shape({
        isMonitored: PropTypes.bool,
    }),
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...sensorActions, clearDownloadMeasurementStore, clearOperationalParametersApiErrors }, dispatch)
    };
};

const operationalParamsContainerWithErrorBoundaryTrigger = withErrorBoundaryTrigger(OperationalParametersContainer);
const OperationalParametersContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(operationalParamsContainerWithErrorBoundaryTrigger);


export default OperationalParametersContainerConn;
